<div class="property-warehouse-container">
  <form #propertyWarehouseForm="ngForm" class="property-warehouse-form">
    <div class="section-header mb-3">
      <h5>Property Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Property Address</label>
        <text-input
          [(ngModel)]="formData.propertyAddress"
          name="propertyAddress"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-3 mb-3">
        <label class="form-label">City</label>
        <text-input
          [(ngModel)]="formData.city"
          name="city"
          [readonly]="true">
        </text-input>
      </div>

      <div class="col-md-1 mb-3">
        <label class="form-label">State</label>
        <select class="form-select"
          name="state"
          [(ngModel)]="formData.state"
          [disabled]="true">
          <option value="">-- Select State --</option>
          @for (state of states; track state.value) {
            <option [value]="state.value">
              {{ state.name }}
            </option>
          }
        </select>
      </div>

      <div class="col-md-2 mb-3">
        <label class="form-label">Zip</label>
        <text-input
          [(ngModel)]="formData.zip"
          name="zip"
          [readonly]="true">
        </text-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <label class="form-label">Property Type</label>
        <text-input
          [ngModel]="propertyTypeDisplay"
          name="propertyType"
          [readonly]="true">
        </text-input>
      </div>

      <!-- MERS MIN - hidden for ICD flow, shown for Doc Order flow -->
      @if (!isIcdFlow) {
        <div class="col-md-6">
          <label class="form-label">MERS MIN <span class="text-danger">*</span></label>
          <text-input
            [(ngModel)]="formData.mersMin"
            #mersMinField="ngModel"
            name="mersMin"
            [required]="true">
          </text-input>
        </div>
      }
    </div>

    <div class="section-header mb-3 mt-4">
      <h5>Title Information</h5>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <label class="form-label">Manner Title Held As <span class="text-danger">*</span></label>
        <select
          class="form-select"
          [(ngModel)]="formData.mannerTitleHeldAs"
          #mannerTitleHeldAsField="ngModel"
          name="mannerTitleHeldAs"
          required>
          <option [ngValue]="null">-- Select --</option>
          @for (option of mannerTitleHeldAsOptions; track option.value) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
        @if (mannerTitleHeldAsField.invalid && mannerTitleHeldAsField.touched) {
          <div class="text-danger">
            @if (mannerTitleHeldAsField.errors?.required) {
              <small>Manner Title Held As is required</small>
            }
          </div>
        }
      </div>

      <div class="col-md-6 mb-3">
        <label class="form-label">Vesting</label>
        <text-input
          [(ngModel)]="formData.vesting"
          #vestingField="ngModel"
          name="vesting"
          [required]="true">
        </text-input>
        @if (vestingField.invalid && vestingField.touched) {
          <div class="text-danger">
            @if (vestingField.errors?.required) {
              <small>Vesting is required</small>
            }
          </div>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 mb-3">
        <label class="form-label">Will a POA be used?</label>
        <select
          class="form-select"
          [(ngModel)]="formData.willPoaBeUsed"
          name="willPoaBeUsed">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>

      <div class="col-md-3 mb-3">
        <label class="form-label">Will this loan close in a trust?</label>
        <select
          class="form-select"
          [(ngModel)]="formData.willLoanCloseInTrust"
          name="willLoanCloseInTrust">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>

      <!-- LLC field - shown for both ICD and Doc Order flows -->
      <div class="col-md-3 mb-3">
        <label class="form-label">Will vesting be held in a LLC?</label>
        <select
          class="form-select"
          [(ngModel)]="formData.isLlc"
          name="isLlc">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>

      <div class="col-md-3 mb-3">
        <label class="form-label">Non-Borrower Title Holder</label>
        <select
          class="form-select"
          [(ngModel)]="formData.nonBorrowerTitleHolder"
          name="nonBorrowerTitleHolder">
          @for (option of yesNoOptions; track option.label) {
            <option [ngValue]="option.value">
              {{ option.label }}
            </option>
          }
        </select>
      </div>
    </div>

    @if (showNonBorrowerFields) {
      <div class="conditional-fields">
      <div class="section-header mb-3 mt-2">
        <h5>Non-Borrower Title Holder Information</h5>
      </div>

        <div class="row">
          <div class="col-md-4 mb-3">
            <label class="form-label">Name <span class="text-danger">*</span></label>
            <text-input
              [(ngModel)]="formData.nonBorrowerName"
              name="nonBorrowerName"
              [required]="true">
            </text-input>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">Phone <span class="text-danger">*</span></label>
            <text-input
              [(ngModel)]="formData.nonBorrowerPhone"
              name="nonBorrowerPhone"
              [required]="true">
            </text-input>
          </div>
          <div class="col-md-4 mb-3">
            <label class="form-label">Email <span class="text-danger">*</span></label>
            <text-input
              [(ngModel)]="formData.nonBorrowerEmail"
              name="nonBorrowerEmail"
              [required]="true"
              pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}">
            </text-input>
          </div>
        </div>
      </div>
    }

    <!-- Warehouse Information - hidden for ICD flow, shown for Doc Order flow -->
    @if (!isIcdFlow) {
      <div class="section-header mb-3 mt-4">
        <h5>Warehouse Information</h5>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3">
          <label class="form-label">Warehouse <span class="text-danger">*</span></label>
          <text-input
            [(ngModel)]="formData.warehouse"
            #warehouseField="ngModel"
            name="warehouse"
            [required]="true">
          </text-input>
          @if (warehouseField.invalid && warehouseField.touched) {
            <div class="text-danger">
              @if (warehouseField.errors?.required) {
                <small>Warehouse is required</small>
              }
            </div>
          }
        </div>
      </div>
    }
  </form>
</div>
